module.exports = {
  title: '用户纠错及新增',
  route: {
    path: '/platform-goods-manage',
    children: {
      path: 'oem-user-error-correction',
    },
  },
};
